import { createPortal } from 'react-dom';
import { Context } from "./jobs-wrapper";
import Facets, { resetFacets } from "./facets.js";
import { useState, useContext, useRef, useEffect } from "react";
import { removeMainCat, getFullState, FixAnyOfTheseJobType, getAbbrState } from '../helpers/helpers.js';
import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Cookies from 'js-cookie';
import Grow from '@mui/material/Grow';
import { CheckBoxOutlineBlank, CheckBox } from '@mui/icons-material';

const JobFilterModal = () => {

  const [inputValueLocations, setInputValueLocations] = React.useState('');

  const { data, updateJobParams, loading, updateInputs, modalJobSearchUsed, updateModalJobSearchUsed } = useContext(Context);

  //  const {data, loading} = useContext(Context);
  const stateCheckboxValues = useRef([]); //retains state/city list after a filtered search - structure: [{"key":"AK","doc_count":57,"city-list":{"doc_count_error_upper_bound":0,"sum_other_doc_count":0,"buckets":[{"key":"Anchorage","doc_count":19,"state":"AK"},{"key":"Anchorage ","doc_count":1,"state":"AK"},{"key":"Barrow","doc_count":7,"state":"AK"}]
  const categoryCheckboxValues = useRef([]); //retains cat list after a filtered search - structure: [{"key":"Schools - Adaptive Physical Education Teacher","doc_count":3,"cleaned_key":"Adaptive Physical Education Teacher"}]
  const firstLoadPerformed = useRef(""); //sets initial data in the respective stateCheckboxValues and categoryCheckboxValues
  const [selectedOption, setSelectedOption] = React.useState(null);
  const [selectedLocationOption, setSelectedLocationOption] = React.useState(null);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleSelectJobTitle = (event, newValue) => {
    setSelectedOption(newValue);
  };

  const handleSelectLocation = (event, newValue) => {
    setSelectedLocationOption(newValue);
  };

  const jobTitleRenderInput = ((params) => (
    <TextField
      {...params}
      label="Job Title (optional)"
      placeholder="Job Title"
      variant="standard"
      className="job-title-input"
    />
  ));
  const jobLocationRenderInput = ((params) => (
    <TextField
      {...params}
      label="Location (optional)"
      placeholder="Location"
      variant="standard"
      className="job-location-input"
        onBlur={() => {
        const event = new KeyboardEvent('keydown', {
          key: 'Enter',
          code: 'Enter',
          which: 13,
          keyCode: 13,
          bubbles: true,
          cancelable: true
        });

        const selectJobLocation = document.querySelector('.job-location-input');
        const selectJobLocationInput = document.querySelector('.job-location-input input');

        if (typeof selectJobLocationInput !== 'undefined') {
          if (selectJobLocationInput.value !== "") {
            document.getElementsByClassName('job-location-input')[0].dispatchEvent(event);
          }
        }
      }}
    />
  ));

  const jobTitleRenderOption = ((props, option, { selected }) => {
    const { key, ...optionProps } = props;
    return (
      <li key={key} {...optionProps} className="job-title-data-listitem">
        <input type="checkbox"
          tabIndex={-1} // Set tabIndex to -1 to prevent focus
          icon={<CheckBoxOutlineBlank />}
          checkedIcon={<CheckBox />}
          style={{ marginRight: 8 }}
          checked={selected}
          onChange={(event, option) => {
            option.checked = event.target.checked;
            props.onClick(event);
            props.forceUpdate();
          }}
          size="large"
        />
        {option.label}
      </li>
    );
  });
  const jobLocationRenderOption = ((props, option) => {
    return (
      <li {...props} className="job-location-data-listitem">
        {option}
      </li>
    );
  });
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const [loadingLocations, setLoadingLocations] = React.useState(false);
  const [modalOpen, setModalOpen] = React.useState(false);
  const handleModalOpen = (event) => {
    event.preventDefault(); // Prevent default behavior
    setModalOpen(true);
    setAnchorEl(event.currentTarget);
  };
  const handleModalClose = () => {
    setModalOpen(false);
    Cookies.set('modalOpened', true, { expires: 365 }); // Store cookie when modal is closed
    setAnchorEl(null);
  };
  const handleOpenLocations = () => {
    setOpen(true);
    (async () => {
      setLoadingLocations(true);
      setLoadingLocations(false);
      setOptions([...locationData]);
    })();
  };
  const handleCloseLocations = () => {
    setOpen(false);
    setOptions([]);
  };
  /* handle gettting long/lat */
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [loadingGeo, setLoadingGeo] = useState(true);
  const fetchCityAndState = async (lat, lon) => {
    const retrievedUserlocation = JSON.parse(localStorage.getItem('user_location'));

    if (retrievedUserlocation) {
      setCity(retrievedUserlocation.usr_city);
      setState(retrievedUserlocation.usr_state);
      setLoadingGeo(false)
    }
    else {
      const data = new URLSearchParams();
      data.append('action', 'get_city_and_state'); // Action name registered in PHP
      data.append('lat', lat);
      data.append('lon', lon);
      fetch('/wp/wp-admin/admin-ajax.php', {
        method: 'POST',
        body: data,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(response => {
          if (response.success) {
            setCity(response.data.city);
            setState(response.data.state);
            setOptions([
              { city, state },
              // Add more options as needed
            ]);
            localStorage.setItem("user_location", JSON.stringify({ usr_city: response.data.city, usr_state: response.data.state })); //add location to storage so we dont have to keep calling API
            setLoadingGeo(false)
          } else {
            //  console.error('Error retrieving city and state:', response.data);
            setLoadingGeo(false)
          }
        })
        .catch(error => {
          // console.error('There was a problem with the fetch operation:', error);
          setLoadingGeo(false)
        });
    }
  };

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lat = position.coords.latitude;
          const lon = position.coords.longitude;
          // Store lat and lon in localStorage
          localStorage.setItem('user_geolocation', JSON.stringify([lat, lon]));
          fetchCityAndState(lat, lon);
        },
        (error) => {
          setLoadingGeo(false)
          //  console.error("Geolocation error:", error.code, error.message);
        }
      );
    } else {
      setLoadingGeo(false)
      //  console.error("Geolocation is not supported by this browser.");
    }
  }, []);

  /* render open modal button in a diff place */
  const targetDivRef = useRef(null);
  const [hasModalBeenOpened, setHasModalBeenOpened] = useState(false);

  useEffect(() => {
    //  const targetDiv = targetDivRef.current;
    const targetDiv = document.getElementById('jobFilterLink');

    if (targetDiv) {
      const link = document.createElement('a');
      link.textContent = 'Help me find a job I’ll love';
      link.href = '#'; // You can set the href to a specific URL if needed
      link.addEventListener('click', handleModalOpen);
      // Create an SVG icon
      const icon = document.createElement('img');
      icon.src = '/wp-content/themes/soliant/images/icons/search-file.svg'; // Replace with the path to your SVG icon
      icon.alt = 'Help icon'; // Provide an alt text for accessibility
      // Append the icon and link to the target div
      targetDiv.appendChild(link);
    }
  }, []);

  useEffect(() => {
    if (data && data.hits) {
      const hasModalBeenOpenedPreviously = Cookies.get('modalOpened');

      if (hasModalBeenOpenedPreviously) {
        setHasModalBeenOpened(true);
      } else {
        const timeoutId = setTimeout(() => {
          setModalOpen(true);
          setHasModalBeenOpened(true);
          Cookies.set('modalOpened', true, { expires: 365 }); // Store cookie for 1 year
        }, 5000);
        return () => clearTimeout(timeoutId);
      }
    }
  }, [data]);

  const getSynonym = (job_category) => {
    let job_category_match = {
      "Adaptive Physical Education Teacher": "PE",
      "Certified Nursing Assistant": "CNA",
      "COTA": "Certified Occupational Therapy Assistant",
      "CT": "Computed Tomography",
      "CVOR Tech": "Cardiovascular Operating Room Technician",
      "Deaf / Hard of Hearing Specialist": "DHH",
      "Echo": "Echocardiogram Technologist",
      "EEG Tech": "Electroencephalogram Technician",
      "Endo Tech": "Endoscopy Technician",
      "EP Tech": "Electrophysiology Technician",
      "Hospital - OT": "Occuaptional Therapist",
      "Hospital - PT": "Physical Therapist",
      "Hospital - PTA": "Physical Therapist Assistant",
      "Hospital - SLP": "Speech Language Pathologist",
      "Hospital - SLP - CFY": "Clinical Fellowship Year Speech Language Pathologist",
      "IR Tech": "Interventional Radiology Technologist",
      "LPN": "Licensed Practical Nurse",
      "LPN Nurse": "Licensed Practical Nurse",
      "MRI": "Magnetic Resonance Imaging Technologist",
      "Orientation and Mobility Specialist": "O&M Specialist",
      "ORT": "Occupational Rehabilitation Therapist",
      "OT": "Occupational Therapist",
      "OT - Telehealth": "Occupational Therapy",
      "Pharmacy Technician - IV Certified": "Intravenous",
      "PT": "Physical Therapist",
      "PT - Telehealth": "Physical Therapist",
      "PTA": "Physical Therapist Assistant",
      "RN - Cath Lab": "Registered Cardiac Catheterization Nurse",
      "RN - CVOR": "Registered Cardiovascular Operating Room Nurse",
      "RN - Endoscopy": "Registered Nurse",
      "RN - EP": "Registered Electrophysiology Nurse",
      "RN - Home Health": "Registered Home Health Home Care Nurse",
      "RN - Infusion": "Registered Infusion Nurse",
      "RN - IR": "Registered Interventional Radiology Nurse",
      "RN - MS Oncology": "Registered Medical Surgical Oncology Nurse",
      "RN Nurse": "Registered Nurse",
      "RN Nurse - Telehealth": "Telehealth Nurse",
      "RN-CVICU": "Registered Cardiovascular Intensive Care Unit Nurse",
      "RN-Dialysis": "Registered Dialysis Nurse",
      "RN-ER": "Registered Emergency Room Nurse",
      "RN-ICU": "Registered Intensive Care Unit Nurse",
      "RN-MS": "Registered Medical Surgical Nurse",
      "RN-NICU": "Registered Neonatal Intensive Care Unit Nurse",
      "RN-Operating Room": "Registered Operating Room Nurse",
      "RN-PACU": "Registered Post-Anesthesia Care Unit Nurse",
      "RN-PICU": "Registered Post-Anesthesia Care Unit Nurse",
      "RN-Psych": "Registered Pediatric Intensive Care Unit Nurse",
      "RN-Stepdown": "Registered Stepdown Nurse",
      "RN-Tele": "Registered Rehabilitation/Long-Term Care Nurse",
      "Sign Language Interpreter": "SLI",
      "Sign Language Interpreter - Telehealth": "SLI",
      "Skilled - PT": "Physical Therapist",
      "SLP": "Speech Language Pathologist",
      "SLP - CFY": "Clinical Fellowship Year Speech Language Pathologist",
      "SLP - Telespeech": "Speech Language Pathology",
      "SLPA": "Speech Language Pathology Assistant",
      "Special Education Teacher": "SPED",
      "Special Education Teacher - Telehealth": "SPED",
      "Staff Pharmacist - IV Certified": "Intravenous Injections",
      "Teacher of the Deaf / Hard of Hearing": "DHH",
      "Teacher of the Deaf / Hard of Hearing - Telehealth": "DHH",
      "Visually Impaired Teacher": "TVI",
      "Visually Impaired Teacher - Telehealth": "TVI"
    };

    return (job_category_match[job_category] !== undefined) ? job_category + ', ' + job_category_match[job_category] : job_category;
  
}

  if (typeof data.hits !== 'undefined' && firstLoadPerformed.current === "" && loadingGeo === false) {
    categoryCheckboxValues.current = data.aggregations.categorieslist.buckets;
    stateCheckboxValues.current = data.aggregations.stateslist.buckets;
    //console.log("setting data")
    if (city !== '' && state !== '') {
      setSelectedLocationOption([city + ", " + state])
    }
    firstLoadPerformed.current = 'true'
    //console.log("CITY" +JSON.stringify(stateCheckboxValues.current)); // Output: '{"key":"category1","cleaned_key":"Category 1","doc_count":10}'
  }

  const handleModalSubmit = (event) => {
    if (event) { event.preventDefault(); }
    window.cats_from_search = selectedOption ? selectedOption.map(option => option.value) : [];
    window.location_from_search = selectedLocationOption ? selectedLocationOption : [];
    //clear out checkbox selections
    document.querySelectorAll('.jobFacetsInner input[type="checkbox"]').forEach(el => {
      if (el.checked) el.click();
    });
    window.were_facets_used = false;
    updateJobParams({});
    handleModalClose();
    /*clear out search box*/
    window.kw_from_search = "";
    updateInputs({ "keywords": "" })
  }

  const jobTitleData = [];
  const categoryData = categoryCheckboxValues.current.map((row, index) => {
    jobTitleData.push({ label: getSynonym(row['cleaned_key']), value: row['key'] });
  });
  const locationData = [];
  const stateData = stateCheckboxValues.current.map((row, index) => {
    let stateName = row["key"];
    row["city-list"]["buckets"].forEach((city, index) => {
      locationData.push(city["key"] + ", " + stateName);
    })
  });
  if (loadingGeo === false) {
    (city !== "" && state !== "") && locationData.push(city + ", " + state);
  }
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <>
      {createPortal(
        <Modal
          className="job-filter-custom-modal"
          open={modalOpen}
          onClose={handleModalClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          TransitionComponent={Grow}
          TransitionProps={{ direction: "up" }}
        >
          <div class="box-container">
            <div class="container-fluid">
              <div class="row">
                <button
                  aria-label="close"
                  onClick={handleModalClose}
                  className="custom-close-button">
                  <svg class="close-icon" viewBox="0 0 24 24"><path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path></svg>
                </button>
                <h4 id="modal-modal-title" className="job-modal-title">
                  <img src="/wp-content/themes/soliant/images/icons/search-file-teal.svg" style={{ marginRight: "10px" }} />
                  Discover Jobs Recommended Just for You
                </h4>
              </div>
            </div>
            {data && data.hits ? (
              <div class="container-fluid">
                <div class="row">
                  <form
                    Id="frm-jobFilter-modal"
                    class="col-xs-12 frmJobFilter noLeftP noRightP"
                    aria-label="Discover jobs"
                    onSubmit={handleModalSubmit}
                  >
                    <div class="form-group">
                      <label class="field-label">I work as a(n)</label>
                      <Autocomplete
                        size="medium"
                        multiple
                        popupIcon={<KeyboardArrowDownIcon fontSize="large" style={{ fontSize: 20 }} />}
                        id="job-title-data"
                        options={jobTitleData}
                        getOptionLabel={(jobTitle) => jobTitle.label} // What the user sees
                        disableCloseOnSelect
                        renderOption={jobTitleRenderOption}
                        onClose={(event,reason) => {
                          event.stopPropagation();
                          if (reason === "blur" || reason === "escape") {
                            setIsOpen(false);
                         }
                        }}
                        onOpen={(event) => {
                          event.stopPropagation();
                          setIsOpen(true)
                        }}
                        isOptionEqualToValue={(jobTitle, value) =>
                          jobTitle.value === value.value
                        }
                        onChange={handleSelectJobTitle}
                        renderInput={jobTitleRenderInput}
                        value={selectedOption ? selectedOption : []}
                      />
                    </div>
                    <div class="form-group">
                      <label class="field-label">looking for jobs in</label>
                      <Autocomplete
                        multiple
                        popupIcon={<KeyboardArrowDownIcon fontSize="large" />}
                        freeSolo
                        minLength={3}
                        className="job-location-input"
                        open={inputValueLocations.length >= 3 && open}
                        onOpen={handleOpenLocations}
                        renderOption={jobLocationRenderOption}
                        onClose={handleCloseLocations}
                        isOptionEqualToValue={(option, value) => option === value}
                        getOptionLabel={(option) => option}
                        options={locationData}
                        onChange={handleSelectLocation}
                        renderInput={jobLocationRenderInput}
                        onInputChange={(event, newInputValueLocations) =>
                          setInputValueLocations(newInputValueLocations)                
                        }
                        value={
                          selectedLocationOption ? selectedLocationOption : []
                        }
                        loading={loadingGeo}
                      />
                    </div>
                    <div class="col-sm-6 noLeftP noRightP discover-jobs-container">
                      <button type="submit" class="btn btn-default col-xs-12" id="btn-discoverJobs" aria-label="Find your next job">
                        Find my next job
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            ) : (
              <div class="container-fluid">
                <div class="row">
                  <div class="text-center pt-5"><img alt="progress" src="/wp-content/themes/soliant/images/icons/modal-loading.gif" id="progress" /></div>
                </div>
              </div>
            )}
          </div>
        </Modal>,
        document.getElementById("jobFilterModalElement")
      )}
    </>
  );
}

export default JobFilterModal;